// extracted by mini-css-extract-plugin
module.exports = {"ServicesWrap":"ServicesWrap_ServicesWrap__O7P7d"};